<template>
  <div id="app" class="app_div">
    <div class="alarm_button_div" @click="alarmClick">
      <div class="icon_alarm_bag" :style="{ backgroundImage: `url(${isHovered ? alarmBagHoverImage : alarmBagImage})` }"></div>
      <div class="icon_alarm_one" :style="{ backgroundImage: `url(${isHovered ? alarmOneHoverImage : alarmOneImage})` }"></div>
      <div class="icon_alarm_two"></div>
      <div class="icon_alarm_three"></div>
      <div class="icon_alarm_four"></div>
      <div class="icon_alarm_five"></div>
      <div class="icon_alarm_six" @mouseover="onMouseOver" @mouseout="onMouseOut"></div>
    </div>
    <top-head></top-head>
    <div class="main_div">
      <!-- <div class="left_border_div"></div>
      <div class="right_border_div"></div>
      <div class="bottom_border_div"></div> -->
      <div class="left_main_div">
        <left-menu></left-menu>
      </div>
      <div class="right_main_div">
        <div class="main_data_div">
          <!--          必须加上可以，不然同页面跳转不会刷新页面-->
          <router-view />
        </div>
      </div>
    </div>

    <!-- 控制窗体弹窗 -->
    <transition name="el-fade-in">
      <ControlPopover v-if="showControl"></ControlPopover>
    </transition>
    <!-- 告警弹窗 -->
    <transition name="el-fade-in">
      <WarningCenter v-if="showWarningCenter"></WarningCenter>
    </transition>
    <!-- 详情弹窗 -->
    <detailWindow v-show="showDetail"></detailWindow>
  </div>
</template>

<script>
import topHead from "@/components/iems/top-head";
import leftMenu from "@/components/iems/left-menu";
import message from "@/components/iems/message";
import ControlPopover from "@/components/iems/Control-popover.vue";
import WarningCenter from "@/components/iems/warning-center.vue";
import { mapState, mapMutations } from "vuex";
import detailWindow from "@/components/iems/detail-window.vue";
export default {
  name: "Home",
  components: {
    topHead,
    leftMenu,
    message,
    ControlPopover,
    WarningCenter,
    detailWindow,
  },
  data() {
    return {
      isHovered: false,
      alarmBagImage: require('@/assets/images/iems/icon_alarm_bag.png'),
      alarmBagHoverImage: require('@/assets/images/iems/icon_alarm_bag_hover.png'),
      alarmOneImage: require('@/assets/images/iems/icon_alarm_one.png'),
      alarmOneHoverImage: require('@/assets/images/iems/icon_alarm_one_hover.png'),
    };
  },
  computed: {
    ...mapState("controlPopover", [
      "showControl",
      "id",
      "showWarningCenter",
      "showControlNew",
    ]),
    ...mapState("detailWindow", ["showDetail"]),
  },
  methods: {
    ...mapMutations("controlPopover", ["openWarning", "closeWarning"]),
    
    // 告警图表鼠标移入事件
    onMouseOver() {
      this.isHovered = true;
    },
    onMouseOut() {
      this.isHovered = false;
    },
    // 打开告警弹窗
    alarmClick() {
      this.openWarning();
    },
  },
  created() {},
  mounted() {},
  watch: {},
};
</script>

<style scoped>
@import "../assets/css/home.css";

.alarm_button_div {
    position: relative;
    width: 4%;
    position: relative;
    display: inline-block;
    vertical-align: top;
    /* border: 1px solid red; */
}
.icon_alarm_bag {
    position: absolute;
    width: 6rem;
    height: 6rem;

    top: 0.5rem;
    left: 1rem;

    /* background-image: url("../images/iems/icon_alarm_bag.png"); */
    background-size: 100% 100%;
    background-color: transparent;
    cursor: pointer;
}

.icon_alarm_one {
    position: absolute;
    width: 5.5rem;
    height: 5.5rem;

    top: 0.75rem;
    left: 1.3rem;

    /* background-image: url("../images/iems/icon_alarm_one.png"); */
    background-size: 100% 100%;
    background-color: transparent;
    /* border: 1px solid red; */
}

.icon_alarm_two {
    position: absolute;
    width: 3.5rem;
    height: 3.5rem;
    top: 1.5rem;
    left: 2.4rem;

    animation: rotate 10s linear infinite;
    background-image: url("~@/assets/images/iems/icon_alarm_two.png");
    background-size: 100% 100%;
    background-color: transparent;
    /* border: 1px solid white; */
}
.icon_alarm_three {
    position: absolute;
    width: 4rem;
    height: 4.1rem;

    top: 1.3rem;
    left: 2.2rem;

    animation: rotate_reverse 5s linear infinite;
    background-image: url("~@/assets/images/iems/icon_alarm_three.png");
    background-size: 100% 100%;
    background-color: transparent;
    /* border: 1px solid white; */
}
.icon_alarm_four {
    position: absolute;
    width: 4.5rem;
    height: 4.5rem;

    top: 1.1rem;
    left: 2rem;

    animation: rotate 10s linear infinite;
    background-image: url("~@/assets/images/iems/icon_alarm_four.png");
    background-size: 100% 100%;
    background-color: transparent;
    /* border: 1px solid red; */
}

.icon_alarm_five {
    position: absolute;
    width: 4.9rem;
    height: 4.9rem;
    
    top: 0.85rem;
    left: 1.75rem;

    animation: rotate_reverse 5s linear infinite;
    background-image: url("~@/assets/images/iems/icon_alarm_five.png");
    background-size: 100% 100%;
    background-color: transparent;
    /* border: 1px solid red; */
}
.icon_alarm_six {
    position: absolute;
    width: 5.2rem;
    height: 5.2rem;

    top: 0.9rem;
    left:1.3rem;
    background-image: url("~@/assets/images/iems/icon_alarm_six.png");
    background-size: 100% 100%;
    background-color: transparent;
    cursor: pointer;
}
@keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes rotate_reverse {
    from {
      transform: rotate(360deg);
    }
    to {
      transform: rotate(0deg);
    }
  }

</style>

//computed：用来监控自己定义的变量，该变量不在data里面声明，直接在computed里面定义，然后就可以在页面上进行双向数据绑定展示出结果或者用作其他处理
//methods：methods 将被混入到 Vue 实例中。可以直接通过 VM 实例访问这些方法，或者在指令表达式中使用。方法中的 this 自动绑定为 Vue 实例，放方法的
//mounted：实例被挂载后调用，这时 el 被新创建的 vm.$el 替换了。如果根实例挂载到了一个文档内的元素上，当 mounted 被调用时 vm.$el 也在文档内。放事件的
//created：在实例创建完成后被立即同步调用。在这一步中，实例已完成对选项的处理，意味着以下内容已被配置完毕：数据侦听、计算属性、方法、事件/侦听器的回调函数。然而，挂载阶段还没开始，且 $el property 目前尚不可用。
//props： 可以是数组或对象，用于接收来自父组件的数据
//watch：一个对象，键是需要观察的表达式，值是对应回调函数。值也可以是方法名，或者包含选项的对象。Vue 实例将会在实例化时调用 $watch()，遍历 watch 对象的每一个 property。监听值的